import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel"]

  connect() {
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("click", this.closeOnOutsideClick)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
    document.removeEventListener("keydown", this.closeOnEscape)
    clearTimeout(this.closeTimer)
  }

  toggle(event) {
    event.stopPropagation()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    clearTimeout(this.closeTimer)
    this.panelTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
    requestAnimationFrame(() => {
      this.element.classList.add("is-open")
    })
  }

  close() {
    clearTimeout(this.closeTimer)
    this.triggerTarget.setAttribute("aria-expanded", "false")
    this.element.classList.remove("is-open")
    this.closeTimer = setTimeout(() => {
      this.panelTarget.hidden = true
    }, 160)
  }

  closeOnOutsideClick(event) {
    if (!this.isOpen || this.element.contains(event.target)) return

    this.close()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.isOpen) return

    this.close()
    this.triggerTarget.focus()
  }

  get isOpen() {
    return this.element.classList.contains("is-open")
  }
}
